import Vue from "vue"
import Router from "vue-router"
import Home from "@/components/Home"
import Question1 from "@/components/Question1"
import Question2 from "@/components/Question2"
import Question3 from "@/components/Question3"
import Question4 from "@/components/Question4"
import Question5 from "@/components/Question5"
import Result from "@/components/Result"

Vue.use(Router)

export default new Router({
	routes: [
		{
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/question1',
      name: 'Question1',
      component: Question1,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/question2',
      name: 'Question2',
      component: Question2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/question3',
      name: 'Question3',
      component: Question3,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/question4',
      name: 'Question4',
      component: Question4,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/question5',
      name: 'Question5',
      component: Question5,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/result',
      name: 'Result',
      component: Result,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '*',
      redirect: '/'
		}
	]
})